export const header = [
  {
    id: 1,
    name: 'Necessary',
    content:
      'Necessary cookies are required to enable the basic features of this site, such as providing secure log-in or adjusting your consent preferences. These cookies do not store any personally identifiable data.',
  },
  {
    id: 2,
    name: 'Functional',
    content:
      'Functional cookies help perform certain functionalities like sharing the content of the website on social media platforms, collecting feedback, and other third-party features.',
  },
  {
    id: 3,
    name: 'Analytics',
    content:
      'Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information on metrics such as the number of visitors, bounce rate, traffic source, etc.',
  },
  {
    id: 4,
    name: 'Performance',
    content:
      'Performance cookies are used to understand and analyze the key performance indexes of the website which helps in delivering a better user experience for the visitors.',
  },
  {
    id: 5,
    name: 'Advertisement',
    content:
      'Advertisement cookies are used to provide visitors with customized advertisements based on the pages you visited previously and to analyze the effectiveness of the ad campaigns.',
  },
  {
    id: 6,
    name: 'Uncategorized',
    content:
      'Other uncategorized cookies are those that are being analyzed and have not been classified into a category as yet.',
  },
];
